<template>
  <fragment>
    <div>
      <div class="wraper">
        <div class="container-fluid mycontainer-fluid content">
          <slot name="header" />
          <div class="row myrow">
            <div class="col-xs-12 mycol header-title">
              <div class="col-xs-12 mycol">
                <div class="h-t-name pull-left">Администрирование</div>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid mycontainer-fluid content">
          <div class="df-js-b df-al admin-legend--container">
            <div class="breadcrumb-wrapp">
              <a href="/administration/">Администрирование</a> >
              <span>Проверка ЭЦП файла, загруженного в систему с использование hash-преобразования</span>
            </div>
          </div>

          <div style="padding: 8px;">

            <h4>Выберите проект:</h4>
            <div class="row">
              <div class="col-md-12">
                <v-autocomplete
                  :items="items"
                  input-class="form-control"
                  :auto-select-one-item="false"
                  :keep-open="false"
                  :component-item="act"
                  v-model="selectedProject"
                  :min-len="1"
                  :get-label="getLabel"
                  placeholder="Введите номер проекта"
                  @update-items="updateItems"
                  @input="selectProjectItems"
                ></v-autocomplete>
              </div>
            </div>
            <br>

            <div class="row" v-show="isLoadListDocuments" style="padding-top: 10px; color:orange; ">
              <div class="col-md-12">
                <h4>Загрузка документов проекта
                  <img src="/img/waiting.gif" style="width:20px;" />
                </h4>
              </div>
            </div>

            <template v-if="this.docList !== null">
              <h4>Выберите загруженный в систему файл:</h4>
              <h5><strong>Раздел документа</strong>:</h5>
              <div class="row">
                <div class="col-md-12" style="padding-bottom: 10px;">
                  <select
                    class="form-control form-control_dis"
                    v-model="selectedSection"
                    id="sort_add"
                  >
                    <option value="" disabled selected
                    >Выберите раздел документа
                    </option>
                    <option
                      v-for="item in getAllSectionList()"
                      v-if="item.SECTION_ID"
                      v-bind:key="item.SECTION_ID"
                      v-bind:value="item.SECTION_ID"
                      v-text="item.SECTION_NAME"
                      class="form-control"
                    ></option>
                  </select>
                </div>
              </div>
            </template>

            <template v-if="selectedSection > 0">
              <h5><strong>Файл документа</strong>:</h5>
              <div class="row">
                <div class="col-md-12" style="padding-bottom: 10px;">
                  <select
                    class="form-control form-control_dis"
                    v-model="selectedFile"
                    id="sort_add"
                  >
                    <option value="" disabled selected
                    >Выберите файл документа
                    </option>
                    <option
                      v-for="item in listActiveDocBySection()"
                      v-bind:key="item.ID"
                      v-bind:value="item.ID"
                      v-text="item.UF_NAME"
                      class="form-control"
                      @change="changeFileAction"
                    ></option>
                  </select>
                </div>
              </div>
            </template>

            <template v-if="selectedFile > 0">
              <h5><strong>Загрузка файла для проверки</strong>:</h5>
              <div class="row">
                <div class="col-md-12" style="padding-bottom: 10px;">
                  <form
                    action="#"
                    class="load-doc"
                    style="padding-right: 20px"
                  >

                    <div style="display: inline-block">
                      <input
                        type="file"
                        ref="file"
                        @change="changeFile"
                        style="display: none"
                      />
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="$refs.file.click()"
                      >
                        Выберите файл
                      </button>
                    </div>
                    <div style="display: inline-block"><span v-text="fileName2"></span></div>

                    <div class="alert alert-info" style="margin-top: 8px;">
                      Максимальный размер файла для загрузки - 100 Мб.
                    </div>

                    <div v-if="errorText" class="alert alert-danger" style="margin-top: 8px;">>
                      {{ errorText }}
                    </div>

                    <div v-if="isViewButtonSend">
                      <button
                        type="button"
                        class="btn btn-success"
                        @click="getNewHashFile()"
                      >
                        Запустить проверку
                      </button>
                      <button
                        type="button"
                        class="btn btn-default"
                        style="padding: 10px 15px"
                        @click="resetForm()"
                      >
                        Очистить
                      </button>
                    </div>

                    <div v-show="showLoaderIconHashFile" style="padding-top: 10px; color:orange ">
                      Идет формирование хеш-файла загруженного документа и запуск процедуры сравнения данных
                      <img src="/img/waiting.gif" style="width:20px;" />
                    </div>

                  </form>
                </div>
              </div>
            </template>

            <template v-if="isViewResultChangeHash">
              <h5><strong>Результат проверки данных</strong>:
                <span
                  v-if="selectedFileInfo.UF_HASH === hashCheckFile"
                  style="padding:2px; color:green"
                ><strong>Хеши файлов совпадают</strong></span>
                <span
                  v-else
                  style="padding:2px; color:red"
                ><strong>Хеши файлов не совпадают</strong></span>
              </h5>
              <br />
              <div class="row">
                <div class="col-md-12" style="padding-bottom: 10px;">
                  <div class="form-group">Хэш-файла, загруженного в проекте: <span
                    style="padding:2px; background: #C4C4C4">{{ selectedFileInfo.UF_HASH }}</span></div>
                  <div class="form-group">Хэш-файла, загруженного на проверку: <span
                    style="padding:2px; background: #C4C4C4">{{ hashCheckFile }}</span></div>
                </div>
              </div>
              <div class="row">
                <div v-if="ecpData && selectedFileInfo">
                  <h3 class="esd-title">Сведения о сертификате ЭП</h3>
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-xs-4 col-md-4 stl-col-pb-8">
                        Сертификат:
                      </div>
                      <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn esd_wsn">
                        {{ ecpData.SERTIFICATE_NUMBER }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-4 col-md-4 stl-col-pb-8">Кем выдан:</div>
                      <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                        {{ ecpData.ISSUER }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-4 col-md-4 stl-col-pb-8">
                        Организация:
                      </div>
                      <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                        {{ ecpData.COMPANY }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-4 col-md-4 stl-col-pb-8">
                        Кому выдан:
                      </div>
                      <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                        {{ ecpData.OWNER_FIO }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-4 col-md-4 stl-col-pb-8">
                        Действителен:
                      </div>
                      <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                        {{ ecpData.DATE_USE_SERTIFICATE }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-4 col-md-4 stl-col-pb-8">
                        Название документа:
                      </div>
                      <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                        {{ ecpData.FILE_NAME }}
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-xs-4 col-md-4 stl-col-pb-8">
                        Дата загрузки:
                      </div>
                      <div class="col-xs-8 col-md-8 stl-col-pb-8 esd_wsn">
                        {{ selectedFileInfo.UF_FILE_DATE_LOAD }}
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </template>

          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_ADMIN_STATUS_DOCS_LIST,
  SET_IS_VIEW_ALL_EXPERTISE,
  SET_MAIN_MENU
} from "@/store/actions.type";
import { AdminService, ExpertAdvice, ProjectsService } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import Multiselect from "vue-multiselect";
import Item from "@/components/expert/Item.vue";
import Vue from "vue";

export default {
  name: "EDS",
  title: "Проверка ЭЦП файла",
  components: { Multiselect },
  data() {
    return {
      siteUrl: "",
      items: [],
      act: Item,
      isEdit: false,
      showStatusHistory: false,
      commentActual: [],
      showCommentDialog: false,
      filter: {
        type: "all"
      },
      selectedProject: null,
      selectedSection: 0,
      docList: null,
      docListByType: null,
      isLoadListDocuments: false,
      selectedFile: 0,
      hashCheckFile: "",
      addDocForm: {
        FILE_NAME: "",
        FILE: ""
      },
      fileName: "Файл не выбран",
      fileName2: "",
      accept: "",
      showLoadFile: false,
      showLoaderIconHashFile: false,
      errorText: "",
      isViewButtonSend: false,
      isViewResultChangeHash: false,
      selectedFileInfo: null,
      ecpData: null
    };
  },

  computed: {
    ...mapGetters([
      "programList",
      "managerList",
      "statusLoadProgramList"
    ])
  },

  mounted() {
    this.siteUrl = AUTH_URL.replace(new RegExp("[\\/]+$"), "");

    this.$store.dispatch(SET_MAIN_MENU, []);
    ProjectsService.getManagerRoleDefaultSetting().then(({ data }) => {
      this.isEdit = data.SETTING_RULES_ADMIN_MODULE.REPORTING_DOCUMENTS_IS_EDIT;
      let navMainMenu = [];
      if (data.START_PAGE === "REESTR_PROJECTS") {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        if (data.IS_VIEW_ADMIN_MODULE) {
          navMainMenu.push({
            name: "Администрирование",
            route: "Administration"
          });
        }
      } else {
        if (data.IS_REESTR_PROJECTS) {
          navMainMenu.push({
            name: "Реестр проектов",
            route: "Projects"
          });
        }
        if (data.IS_REESTR_EXPERTISE) {
          navMainMenu.push({
            name: "Реестр экспертиз",
            route: "Expertise"
          });
        }
        if (data.IS_VIEW_ADMIN_MODULE) {
          navMainMenu.push({
            name: "Администрирование",
            route: "Administration"
          });
        }
      }
      this.$store.dispatch(SET_MAIN_MENU, navMainMenu);
      this.$store.dispatch(
        SET_IS_VIEW_ALL_EXPERTISE,
        data.IS_VIEW_ALL_EXPERTISE
      );
    });

    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    getLabel(item) {
      if (item) {
        return item.UF_NUMBER + " " + item.UF_NAME;
      }
    },
    updateItems(query) {
      ExpertAdvice.searchProject({ search: query }).then(({ data }) => {
        this.items = data;
      });
    },
    selectProjectItems() {
      /* this.isLoadListDocuments = false;
       this.showLoadFile = false;
       this.showLoaderIconHashFile = false;
       this.hashCheckFile = "";
       this.selectedFile = 0;
       this.docListByType = null;
       this.selectedFileInfo = null;
       this.errorText = "";
       this.isViewButtonSend = false;
       this.isViewResultChangeHash = false;
       this.ecpData = null;*/

      this.resetForm();

      if (this.selectedProject !== null) {
        if (this.selectedProject.ID > 0) {
          this.isLoadListDocuments = true;
          ProjectsService.getDocumentDZProjects(this.selectedProject.ID).then(
            ({ data }) => {
              this.docList = data;
              this.isLoadListDocuments = false;
            }
          );
        } else {
          this.docList = null;
        }
      }
    },
    listActiveDocBySection() {
      let ret = [];
      this.docList.LIST_TYPE.forEach(function(section) {

        if (section.SECTION_ID === this.selectedSection) {
          section.TYPE_LIST_ID.forEach(function(doc) {
            if (doc.FILE_INFO &&
              doc.FILE_INFO.ID &&
              doc.FILE_INFO.UF_HASH !== null &&
              doc.FILE_INFO.UF_HASH !== "" &&
              doc.FILE_INFO.UF_IS_DETACHED_SIGNATURE === null) {
              ret.push(doc.FILE_INFO);
            }
          }, this);
        } else if (section.CHILD && section.CHILD.length > 0) {
          section.CHILD.forEach(function(sectionLevel2) {
            if (sectionLevel2.TYPE_LIST_ID) {
              sectionLevel2.TYPE_LIST_ID.forEach(function(doc) {
                if (doc.FILE_INFO &&
                  doc.FILE_INFO.ID &&
                  doc.FILE_INFO.UF_HASH !== null &&
                  doc.FILE_INFO.UF_HASH !== "" &&
                  doc.FILE_INFO.UF_IS_DETACHED_SIGNATURE === null) {
                  ret.push(doc.FILE_INFO);
                }
              }, this);
            }
            if (sectionLevel2.CHILD && sectionLevel2.CHILD.length > 0) {
              sectionLevel2.CHILD.forEach(function(sectionLevel3) {
                console.log('level 3');
                console.log(sectionLevel3);
                //if (sectionLevel3.SECTION_ID === this.selectedSection) {
                if (sectionLevel3.RECORD_MODEL_ID === this.selectedSection) {
                  if (sectionLevel3.TYPE_LIST_ID) {
                    sectionLevel3.TYPE_LIST_ID.forEach(function(doc) {
                      if (doc.FILE_INFO &&
                        doc.FILE_INFO.ID &&
                        doc.FILE_INFO.UF_HASH !== null &&
                        doc.FILE_INFO.UF_HASH !== "" &&
                        doc.FILE_INFO.UF_IS_DETACHED_SIGNATURE === null) {
                        ret.push(doc.FILE_INFO);
                      }
                    }, this);
                  }
                }
              }, this);

            }
          }, this);
        }
      }, this);

      this.docListByType = ret;
      return ret;
    },
    handleScroll() {
      var tableTheadSticky = document.querySelector(
        "table.js-table-thead-sticky"
      );
      var theadSticky = document.querySelector("thead.js-thead-sticky");
      var headerHeight = document.querySelector(".header").offsetHeight;

      if (tableTheadSticky.getBoundingClientRect().top <= headerHeight) {
        theadSticky.classList.add("stl-thead-sticky");
        theadSticky.style.top = headerHeight + "px";

        var tableResponsive = tableTheadSticky.closest(".table-responsive");
        if (tableResponsive) {
          tableResponsive.classList.add("table-responsive-clip");
        }
      } else {
        theadSticky.classList.remove("stl-thead-sticky");
        theadSticky.style.top = "0";
      }
    },
    changeFileAction() {
      if (this.selectedFile > 0) {
        this.showLoadFile = true;
      }
    },
    changeFile(e) {
      this.isViewResultChangeHash = false;
      let files = e.target.files;
      if (files.length > 0) {
        let file = files[0];
        if (file.size < 1024 * 1024 * 100) {
          this.fileName = file.name;
          this.fileName2 = file.name;
          this.addDocForm.FILE = file;
          this.addDocForm.FILE_NAME = this.fileName;
          this.isViewButtonSend = true;
        } else {
          this.errorText =
            "Загружаемый файл превышает максимально разрешенный размер. Загрузить можно файл размером не более 100 Мб";
        }
      }
    },
    getNewHashFile() {
      this.hashCheckFile = "";
      this.showLoaderIconHashFile = true;
      let formDataHash = new FormData();
      formDataHash.append("FILE", this.addDocForm.FILE);
      ProjectsService.getHashFile(formDataHash).then(response => {
        this.hashCheckFile = response.data.HASH;
        this.checkResultHashFile();
        this.showLoaderIconHashFile = false;
      }, this);
    },
    checkResultHashFile() {
      this.docListByType.forEach(function(doc) {
        if (doc.ID == this.selectedFile) {
          this.selectedFileInfo = {
            "ID": this.selectedFile,
            "UF_HASH": doc.UF_HASH,
            "UF_NAME": doc.UF_NAME,
            "UF_FILE_DATE_LOAD": doc.UF_FILE_DATE_LOAD
          };
        }
      }, this);

      //получение информации об ЭЦП
      ProjectsService.getECPInfoFileDZ(this.selectedProject.ID, this.selectedFile).then(
        ({ data }) => {
          this.ecpData = data.result;
        }
      );

      this.isViewResultChangeHash = true;

    },
    resetForm() {
      this.isLoadListDocuments = false;
      this.showLoadFile = false;
      this.showLoaderIconHashFile = false;
      this.hashCheckFile = "";
      this.selectedFile = 0;
      this.docListByType = null;
      this.selectedFileInfo = null;
      this.errorText = "";
      this.isViewButtonSend = false;
      this.isViewResultChangeHash = false;
      this.ecpData = null;
      this.fileName2 = null;
    },
    getAllSectionList() {
      let ret = [];
      this.docList.LIST_TYPE.forEach(function(section) {
        ret.push({ "SECTION_ID": section.SECTION_ID, "SECTION_NAME": section.SECTION_NAME });
        if (section.CHILD && section.CHILD.length > 0) {
          section.CHILD.forEach(function(section2) {
            ret.push({ "SECTION_ID": section2.SECTION_ID, "SECTION_NAME": section2.SECTION_NAME });
            if (section2.CHILD && section2.CHILD.length > 0) {
              section2.CHILD.forEach(function(section3) {
                //ret.push({ "SECTION_ID": section3.SECTION_ID, "SECTION_NAME": section3.SECTION_NAME });
                ret.push({ "SECTION_ID": section3.RECORD_MODEL_ID, "SECTION_NAME": section3.SECTION_NAME });
              }, this);
            }
          }, this);
        }
      }, this);

      return ret;
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleScroll);
    }
  }
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
